<template>
    <div class="grant-component text-none pa-0 pa-md-6 pb-0 mb-6 mb-md-0" v-if="grant">
        <div class="number-wrapper d-flex flex-md-row flex-column pr-0 pr-md-4">
            <div class="package-name-wrapper mb-6 mb-md-0">
                <div class="text-left label d-flex flex-row">
                    <img :src="box_icon" class="" />
                    <span class="grant-data ml-2">
                        Uprawnienie nr {{ grantIndex }}
                        <div :class="['status px-3 py-1 ml-2', getGrantClass(grant.status, grant.has_account, grant.expiration_date)]">{{ getGrantStatus(grant.status, grant.has_account, grant.expiration_date) }}</div>

                    </span>
                </div>
            </div>
        </div>
        <div class="date-wrapper d-flex flex-md-row flex-column pr-0 pr-md-4">
            <div class="package-name-wrapper mb-6 mb-md-0">
                <div class="text-left label d-flex flex-row justify-end">
                    <img :src="calendar_icon" class="mr-3" />
                    <span class="label-header">Ważne do</span>
                    <span class="grant-data text-right ml-2">
                        {{ formatDate(grant.expiration_date) }}
                    </span>
                </div>
                <div class="text-left label d-flex flex-row justify-end">
                    <span class="label-header">Nadano</span>
                    <span class="grant-data ml-2">
                        {{ formatDate(grant.granted) }}
                    </span>
                </div>
            </div>
        </div>
        <div class="data-row d-flex flex-md-row flex-column pr-0 pr-md-4">
            <div class="package-name-wrapper mb-6 mb-md-0 w-md-50 w-100">
                <div class="text-left label d-flex flex-row ml-8 justify-space-between justify-md-start justify-md-flex-start">
                    <span class="label-header">Rodzaj materiału</span>
                    <span class="grant-data ml-2">
                        {{ grant.grant_type == "CELLS_MZ_2024" ? "Komórki jajowe" : "Nasienie" }}
                    </span>
                </div>
                <div class="text-left label d-flex flex-row ml-8 justify-space-between justify-md-start justify-md-flex-start">
                    <span class="label-header">Miejsce leczenia</span>
                    <span class="grant-data ml-2">
                        {{ grant?.treatment_location_name ?? "Brak" }}
                    </span>
                </div>
            </div>
            <div class="package-name-wrapper mb-6 mb-md-0 pl-md-16 pl-8 w-md-50 w-100">
                <div class="text-left label d-flex flex-row justify-space-between justify-md-start">
                    <span class="label-header">Imię i Nazwisko</span>
                    <span class="grant-data ml-2">
                        {{ grant.first_name }} 
                        {{ grant.last_name }}
                    </span>
                </div>
                <div class="text-left label d-flex flex-row justify-space-between justify-md-start">
                    <span class="label-header">E-mail</span>
                    <span class="grant-data ml-2">
                        {{ grant.email }}
                    </span>
                </div>
                <div class="text-left label d-flex flex-row justify-space-between justify-md-start">
                    <span class="label-header">PESEL/Data urodzenia</span>
                    <span class="grant-data ml-2">
                        {{ grant.pesel ? grant.pesel : formatDate(grant.birthday) }}
                    </span>
                </div>
                <div class="text-left label d-flex flex-row justify-space-between justify-md-start">
                    <span class="label-header">Numer telefonu</span>
                    <span class="grant-data ml-2">
                        {{ grant.phone_number }}
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import dayjs from "dayjs"
import { computed } from "vue";

export default {
    name: "booking-component",
    data: () => {},
    props: {
        grant: {
            type: Object
        },
        grantIndex: {
            type: Number
        }
    },
    components: {},
    setup() {
        const box_icon = computed({
            get: () => { return require('../../assets/icons/box.svg'); }
        })
        const calendar_icon = computed({
            get: () => { return require('../../assets/icons/calendar.svg'); }
        })
        return {
            box_icon,
            calendar_icon
        }
    },
    methods: {
        formatDate(date) {
            return dayjs(date).format('DD.MM.YYYY')
        },
        getGrantStatus(status, has_account, expiration_date) {
            if(dayjs(expiration_date).isAfter(dayjs())) {
                if(has_account) {
                    switch(status) {
                        case "NOT_USED" : {
                            return "Niewykorzystane";
                        }
                        case "USED" : {
                            return "Wykorzystane";
                        }
                        case "CANCELLED" : {
                            return "Anulowane";
                        }
                    }
                } else {
                    return "Brak konta MT"
                }
            } else {
                return "Przeterminowane"
            }
        },
        getGrantClass(status, has_account, expiration_date) {
            if(dayjs(expiration_date).isAfter(dayjs())) {
                if(has_account) {
                    return status 
                } else {
                    return "NO_ACCOUNT"
                }
            } else {
                return "EXPIRED"
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.phenotype-type {
    position: absolute;
    top: -16px;
    right: -16px;
    border-radius: 16px;
    border: 1px solid gray;
    padding: 4px 8px;
    color: var(--nsb-color-1, #0E346F);
    background: rgb(228, 166, 166);
    box-shadow: 0px 2px 4px rgba(0,0,0,0.4);
    &.accepted {
        color: var(--nsb-color-1, #0E346F);
        background: rgb(202, 236, 202);
    }
}

.grant-component {
    box-sizing: border-box;
    background: white;

    @include nsb-font-container;
    font-size: 14px;
    line-height: 21px;

    display: grid;
    grid-template-columns: 1fr auto;
    grid-template-rows: repeat(3, auto);
    grid-column-gap: 0px;
    grid-row-gap: 0px;

    .number-wrapper {
        grid-area: 1 / 1 / 2 / 2;
        font-size: 16px;
        line-height: 24px;
    }

    .date-wrapper {
        grid-area: 1 / 2 / 2 / 3;
        font-size: 16px;
        line-height: 24px;
    }

    .data-row {
        grid-area: 2 / 1 / 3 / 3;
    }

    .bottom-row {
        grid-area: 3 / 1 / 4 / 3;
    }

    .bottom-bar { 
        grid-area: 4 / 1 / 5 / 4;
    }

    .label {
        @include nsb-select-placeholder;
        font-size: 14px;
        line-height: 21px;
        color: $ds-primary-3;
    }

    .label-header {
        margin-top: 2px;
    }

    .package-name-data {
        @include nsb-font-container;
        font-size: 16px;
        line-height: 24px;
        .product-name {
            @include nsb-font-header-bold;
            font-size: 16px;
            line-height: 24px;
        }
    }

    .grant-data, .recipient-data {
        @include nsb-font-container;
        display: inline-block;
        font-size: 16px;
        line-height: 24px;
        font-weight: 400;
    }

    .status {
        @include nsb-font-container;
        color: $ds-primary;
        border-radius: 12px;
        font-size: 12px;
        line-height: 18px;
        display: inline-block;
        background: magenta;
        &.CANCELLED {
            background: $sd-error-2; 
        }
        &.EXPIRED { 
            background: $sd-error-2; 
        }
        &.USED {
            background: $ds-secondary-3; 
        }
        &.NOT_USED {
            background: $ds-success-2;
        }
        &.NO_ACCOUNT { 
            background: $ds-primary-8; 
        }
    }
    .recipient-data-wrapper {
        border: 1px solid $ds-background;
        border-radius: 4px;
    }

    .panel {
        position: relative;
        border-radius: 12px;
        border: 1px solid transparent !important;
        cursor: pointer;
    }
    .panel:hover {
        border: 1px solid var(--nsb-color-1, #0E346F) !important;
    }
}

@media (max-width: 960px) {
    .grant-component {
        border-bottom: 1px solid $nsb-color-3;
    }

    .bottom-bar { 
        grid-area: 3 / 1 / 4 / 5;
    }
}
</style>